import { createContext, useContext } from 'react';

export interface ITourControlsContext {
    /** Переход на шаг по индексу (для ветвления) */
    goToStep: (index: number, branchLabel?: string) => void;
    /** Есть ли история для кнопки «Назад» */
    canGoBack: boolean;
    /** Действие на action-шаге выполнено (для autoAdvance: false) */
    actionDone: boolean;
}

export const TourControlsContext = createContext<ITourControlsContext>({
    goToStep: () => {},
    canGoBack: false,
    actionDone: false,
});

export const useTourControls = () => useContext(TourControlsContext);
